<template>
	<div>
		<div>
			<div style="font-size:20px;float:left;margin:-40px 0 0 40px;font-weight:600">
				岗位支援-{{ruleForm.id === null || ruleForm.id === '' ? '新增' : '修改'}}</div>
			<el-button
				style="float: right; height: 40px; margin-top: -40px; margin-right: 40px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
				@click="Return">返回</el-button>

			<!-- 主体 -->
			<div style="height:750px;background-color:white;margin:75px 40px 0 40px;overflow-x: hidden">
				<!-- 查询框 -->
				<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="demo-ruleForm">
					<el-row>
						<el-col :span="12">
							<el-form-item label="支援项目" prop="organize_temporary_ids" style="width:100%;margin-top:80px" >
								<el-cascader v-model="ruleForm.organize_temporary_ids" @change="changeCascader"
									style="width:100%" collapse-tags :props="props" :show-all-levels="false">
								</el-cascader>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="12">
							<div @click="StaffFind">
								<el-form-item label="支援人" prop="support_staff" style="width:80%">
									<el-input style="width:595px" v-model="ruleForm.support_staff_name"
										onfocus="this.blur();"></el-input>
								</el-form-item>
							</div>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="支援开始时间" prop="start_date">
								<el-date-picker v-model="ruleForm.start_date" style="width:595px" type="datetime"
									format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="支援结束时间" prop="end_date">
								<el-date-picker v-model="ruleForm.end_date" style="width:595px" type="datetime"
									format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" placeholder="选择日期时间">
								</el-date-picker>
							</el-form-item>
						</el-col>
					</el-row>
					
					<el-row>
						<el-col :span="12">
							<el-form-item label="日工资" prop="daily_wage">
								<el-input v-model="ruleForm.daily_wage" style="width:100%" placeholder="请输入日工资" type="number"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="成本承担方" prop="cost_bearing_party">
								<el-radio v-model="ruleForm.cost_bearing_party" label="0">对方项目承担</el-radio>
								<el-radio v-model="ruleForm.cost_bearing_party" label="1" style="margin-left:-20px">本项目承担</el-radio>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="操作人" prop="operator_name">
								<el-input v-model="ruleForm.operator_name" disabled style="width:100%"></el-input>
							</el-form-item>
						</el-col>
					</el-row>

					<el-row>
						<el-col :span="12">
							<el-form-item label="操作时间" prop="operator_date">
								<el-input v-model="ruleForm.operator_date" disabled style="width:100%"></el-input>
							</el-form-item>
						</el-col>
					</el-row>


					<el-form-item style="margin-left:200px">
						<el-button type="goon" @click="Add('ruleForm')"
							v-show="ruleForm.id === null || ruleForm.id === ''">保存</el-button>
						<el-button type="goon" @click="Update('ruleForm')"
							v-show="ruleForm.id != null && ruleForm.id != ''">修改</el-button>
						<el-button type="addbtn" @click="resetForm('ruleForm')">重置</el-button>
					</el-form-item>
				</el-form>

			</div>

		</div>

		<el-dialog title="选择支援人" :visible.sync="dialogVisible" width="40%" :center="true" :close-on-click-modal="false"
			:show-close="false">
			<el-row>
				<organizeStaff ref="organizeStaff" type="checkbox" :accordion="true"
					@commit="saveChange" :staff_ids_prop="object.staff_ids"></organizeStaff>
			</el-row>
			<el-row style="text-align: center;">
				<el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
			</el-row>
		</el-dialog>

		<!-- <el-dialog title="选择支援项目" :visible.sync="dialogVisibles" width="40%" :center="true" :close-on-click-modal="false"
			:show-close="false">
			<el-row>
				
			</el-row>
		</el-dialog> -->

	</div>
</template>

<script>
	import organizeStaff from '../../../utils/organizeStaff/organizeStaff.vue';
	export default {
		components: {
			organizeStaff: organizeStaff,
		},
		props: ["organizeList"],
		data() {
			var organizeFind = async (e, spare8) => {
				var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
					identification: "1",
					organize_id: e,
					spare8: spare8,
				});
				return organizeList.data;
			};
			return {
				//表单数据
				ruleForm: {
					id: '',
					project_id: '',
					project_name: '',
					support_staff: '',
					support_staff_name: '',
					start_date: '',
					end_date: '',
					daily_wage:'',
					operator_name: this.$globals.user.id ,
					operator_date: '',
					organize_ids:'',
					organize_temporary_ids:'',
					cost_bearing_party:'0',
					supportStaffList:[],
				},

				//暂存数据
				object: {
					staff_ids: [],
					staff_name: "",
					project_id: "",
					project_name: ""
				},
				

				//表单验证
				rules: {
					support_staff: [{
						required: true,
						message: '请选择支援人！',
						trigger: 'blur'
					}],
					start_date: [{
						required: true,
						message: '请选择开始时间！',
						trigger: 'blur'
					}],
					end_date: [{
						required: true,
						message: '请选择结束时间！',
						trigger: 'blur'
					}],
					daily_wage: [{
						required: true,
						message: '请输入日工资！',
						trigger: 'blur'
					}],
				},

				//组织架构数据
				organizeList: [],

				//级联下拉配置
				props: {
					lazy: true,
					async lazyLoad(node, resolve) {
						if (node.level === 0) {
							return resolve(await organizeFind('', 'group'));
						} else {
							resolve(await organizeFind(node.data.id, ''));
						}
					},
					value: "id",
					label: "organize_name",
					children: "organizeList",
					checkStrictly: true,
					multiple: true,
				},

				//用户
				userList: [],

				//页面相关
				dialogVisible: false,
				dialogVisibles:false,
			};
		},
		methods: {
			StaffFind() {
				this.dialogVisible = true;
				this.showtxbm = true;
			},
			StaffFinds() {
				this.dialogVisibles = true;
			},
			//设置确定
			saveChange(e) {
				var change_staff = "";
				e.staff_ids.forEach(item => {
					change_staff += item + ",";
				})

				this.ruleForm.support_staff = change_staff;
				this.ruleForm.support_staff_name = e.staff_name;
				this.supportStaffList = this.ruleForm.support_staff.split(",");
				this.supportStaffList = this.supportStaffList.splice(0,this.supportStaffList.length-1)
				this.dialogVisible = false;
			},
			//项目选择
			changeCascader() {
				this.ruleForm.organize_ids = '';
				this.ruleForm.project_id = this.ruleForm.organize_temporary_ids[this.
					ruleForm.organize_temporary_ids.length - 1][0];
					// this.ruleForm.organize_temporary_ids = this.ruleForm.organize_temporary_ids[this.
					// ruleForm.organize_temporary_ids.length - 1];
			},

			//初始化组织架构及下面的人
			async organizeFind() {
				var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
					identification: "1",
					id: this.condition.project_id
				});
				this.organizeList = this.getTreeData(organizeList.data);
			},
			getTreeData(data) {
				// 循环遍历json数据
				for (var i = 0; i < data.length; i++) {

					if (data[i].organizeList.length < 1) {
						// children若为空数组，则将children设为undefined
						data[i].organizeList = undefined;
					} else {
						// children若不为空数组，则继续 递归调用 本方法
						this.getTreeData(data[i].organizeList);
					}
				}
				return data;
			},
			//添加
			Add(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						var url = 'postSupport/add';
						var record = {
							project_id: this.ruleForm.project_id,
							supportStaffList: this.supportStaffList,
							start_date: this.ruleForm.start_date,
							end_date: this.ruleForm.end_date,
							daily_wage:this.ruleForm.daily_wage,
							operator_name: this.$globals.user.id ,
							operator_date: this.ruleForm.operator_date,
							cost_bearing_party:this.ruleForm.cost_bearing_party,
						};
						var data = await this.$globals.AxiosPost(url, record);
						if (data === '-2000') {
							this.$message.error('服务器未响应！请稍后重试');
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.Return();
							} else {
								this.$message.warning(data);
							}
						}

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			//添加
			Update(formName) {
				this.$refs[formName].validate(async (valid) => {
					if (valid) {
						var url = 'postSupport/modify';
						var record = {
							id: this.ruleForm.id,
							project_id: this.ruleForm.project_id,
							support_staff: this.ruleForm.support_staff,
							start_date: this.ruleForm.start_date,
							end_date: this.ruleForm.end_date,
							operator_name: this.ruleForm.operator_name,
							operator_date: this.ruleForm.operator_date,
							cost_bearing_party:this.ruleForm.cost_bearing_party,
						};
						var data = await this.$globals.AxiosPost(url, record);
						if (data === '-2000') {
							this.$message.error('服务器未响应！请稍后重试');
						} else {
							var code = data.code;
							var data = data.data;
							if (code === '200') {
								this.$message.success(data);
								this.Return();
							} else {
								this.$message.warning(data);
							}
						}

					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			},
			Return() {
				this.$parent.Return();
			}
		},
		async created() {
			// 操作人
			var userList = await this.$globals.AxiosPost("user/selectFind", {});
			this.userList = userList.data;

			this.ruleForm = this.$parent.ruleForm;
		},
		watch: {
			"ruleForm.support_staff"(newValue) {
				this.object.staff_ids = [];
				newValue.split(",").forEach(item => {
					if (item != '' && item != null) {
						this.object.staff_ids.push(parseInt(item));
					}
				})
			},
			"ruleForm.support_staff_name"(newValue) {
				this.object.staff_name = newValue;
			},
			"ruleForm.project_id"(newValue) {
				this.object.project_id = newValue;
			},
			"ruleForm.project_name"(newValue) {
				this.object.project_name = newValue;
			},
		},
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Gwzy_add.vue?3331b210